import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {DataManagementService} from '../../services/data-management.service';
import { DataTableDirective } from 'angular-datatables';
import {Constants} from '../../constants';
import {Subject} from 'rxjs/Subject';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import {AccessService} from '../../services/access.service';
import {AppSettings} from '../../../app-settings';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-outgoing',
    templateUrl: './outgoing.component.html',
    styleUrls: ['./outgoing.component.css']
})
export class OutgoingComponent implements OnInit {
    downloadStudentDocument = AppSettings.JAVA_API + AppSettings.DOWNLOAD_DOCUMENT;
    @ViewChild('registrationDetailsModal') registrationDetailsModal: TemplateRef<any>;
    @ViewChild('editRegistrationModal') editRegistrationModal: TemplateRef<any>;
    @ViewChild('downloadStudentDocumentModal') downloadStudentDocumentModal: TemplateRef<any>;
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    public modalReference: NgbModalRef;
    route: string;
    errorMessage = undefined;
    viewErrorMessage = undefined;
    outgoingTerm;
    documentTypes;
    outgoingTermId = '0';
    selectUndefinedOptionValue = undefined;
    registeredStudents;
    oneStudent;
    oneStudentStatus;
    formData;
    gpaOrWork;
    gpaEligible = false;
    workEligible = false;
    statusId;
    selectedTerm;
    studentDocuments;
    termStudentDetails;
    termId: number = undefined;
    documentTypeId: number = undefined;

    constructor(private modal: NgbModal,
                private dmService: DataManagementService,
                private router: Router,
                private toastr: ToastrService,
                private accessService: AccessService) {
        this.router.events.subscribe(event => {
            this.route = this.router.url;
        });
    }

    validateRegistrations() {
        let validateRegistrationsResponse;
        const that = this;
        const body = {
            outgoing_term_id: this.outgoingTermId,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to validate all the outgoing student registrations?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(body, Constants.VALIDATE_ALL_REGISTRATIONS).subscribe(response => {
                        validateRegistrationsResponse = response;
                        resolve(validateRegistrationsResponse);
                    }, error => {
                        validateRegistrationsResponse = error;
                        reject(validateRegistrationsResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (validateRegistrationsResponse.status === 'success') {
                    that.getRegisteredStudents();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: 'Successfully validated the students registrations. <br><br>' +
                            '<p>Total Applications - ' + validateRegistrationsResponse.data.totalApplications + '</p>' +
                            '<p>Accepted Applications - ' + validateRegistrationsResponse.data.acceptedApplications + '</p>' +
                            '<p>Rejected Applications - ' + validateRegistrationsResponse.data.rejectedApplications + '</p>'
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (validateRegistrationsResponse.status === 'fail') {
                    if (validateRegistrationsResponse.data.hasOwnProperty('message') &&
                        validateRegistrationsResponse.data.message !== null &&
                        validateRegistrationsResponse.data.message !== '' &&
                        validateRegistrationsResponse.data.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: validateRegistrationsResponse.data.message,
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: 'Please contact support team.',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            if (cancel.hasOwnProperty('status') && cancel.status === 404) {
                Swal({
                    type: 'error',
                    title: 'Fail',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: cancel.message,
                }).then(function (res) {
                    console.log(res);
                }, function (timer) {
                    console.log(timer);
                });
            }
        });
    }

    reRender() {
        if (this.registeredStudents !== undefined && this.registeredStudents !== null && this.registeredStudents.length !== 0) {
            try {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                    dtInstance.destroy();
                    this.registeredStudents = undefined;
                    this.getRegisteredStudents();
                });
            } catch (err) {
                console.log(err);
            }
        } else {
            this.getRegisteredStudents();
        }
    }

    getRegisteredStudents(): void {
        for (let i = 0; i < this.outgoingTerm; i++) {
            if (this.outgoingTerm[i].outgoing_term_id === this.outgoingTermId) {
                this.selectedTerm = this.outgoingTerm[i];
            }
        }
        this.dmService.getOne(Constants.REGISTERED_STUDENTS, this.outgoingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.registeredStudents = response.data.students;
                        this.outgoingTermId = response.data.outgoing_term_id;
                        if (this.registeredStudents.length === 0) {
                            this.errorMessage = 'There are no students registered yet.';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        this.errorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = error.message;
                });
    }

    getAllTerms() {
        this.dmService.getAll(Constants.TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.outgoingTerm = response.data.outgoing_terms;
                        this.documentTypes = response.data.document_types;
                    } else if (response.status === 'fail') {
                        if (response.data.hasOwnProperty('message')) {
                            this.errorMessage = response.data.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getFormattedTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).subtract(330, 'minutes').format('YYYY-MM-DD hh:mm a');
    }

    openRegistrationDetailsModal(student) {
        this.modalReference = this.modal.open(this.registrationDetailsModal, {size: 'lg', backdrop: 'static', keyboard: false});
        this.dmService.getOne(Constants.GET_REGISTERED_STUDENT_DETAILS, student.outgoing_student_id)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        if (response.hasOwnProperty('message')) {
                            this.viewErrorMessage = response.message;
                        } else {
                            this.oneStudent = response.data;
                            this.studentDocuments = response.data.student_documents;
                            this.termStudentDetails = response.data.term_student_details;
                            this.oneStudentStatus = student;
                            this.gpaOrWork = student.gpa_or_work;
                            if (this.gpaOrWork === 3) {
                                this.gpaEligible = true;
                                this.workEligible = true;
                            } else if (this.gpaOrWork === 2) {
                                this.workEligible = true;
                            } else if (this.gpaOrWork === 1) {
                                this.gpaEligible = true;
                            }
                            this.statusId = student.status_id === 1 ? undefined : student.status_id;
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('name')) {
                            this.viewErrorMessage = response.sqlMessage;
                        } else if (response.hasOwnProperty('message')) {
                            this.viewErrorMessage = response.message;
                        } else {
                            this.viewErrorMessage = 'Something went wrong, please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.viewErrorMessage = 'Server Error';
                });
    }

    eligibility(value) {
        if (value === 1) {
            this.gpaEligible = !this.gpaEligible;
        } else if (value === 2) {
            this.workEligible = !this.workEligible;
        }
    }

    getCheckboxChecked(value) {
        if (value === 1 && (this.gpaOrWork === 1 || this.gpaOrWork === 3)) {
            return true;
        } else if (value === 2 && (this.gpaOrWork === 2 || this.gpaOrWork === 3)) {
            return true;
        }
        return false;
    }

    submitRegistrationStatus() {
        this.statusId = parseInt(this.statusId, 10);
        if ((this.statusId === 2) && (!this.gpaEligible && !this.workEligible)) {
            Swal({
                type: 'warning',
                title: 'Warning',
                width: 600,
                padding: 80,
                showCancelButton: false,
                showConfirmButton: true,
                text: 'Either gpa or work experience should be checked',
            }).then(function (res) {
                console.log(res);
            }, function (timer) {
                console.log(timer);
            });
            return;
        }
        if (this.statusId !== 2 && this.statusId !== 3) {
            Swal({
                type: 'warning',
                title: 'Warning',
                width: 600,
                padding: 80,
                showCancelButton: false,
                showConfirmButton: true,
                text: 'OIA Action should select either Accepted or Rejected.',
            }).then(function (res) {
                console.log(res);
            }, function (timer) {
                console.log(timer);
            });
            this.statusId = this.oneStudent.status_id === 1 ? undefined : this.oneStudent.status_id;
            return;
        }
        let registrationStatusResponse;
        const that = this;
        const data = {
            id: this.oneStudentStatus.registration_status_id,
            registration_form_id: this.oneStudent.id,
            outgoing_student_id: this.oneStudent.outgoing_student_id,
            outgoing_term_id: this.oneStudent.outgoing_term_id,
            status_id: this.statusId
        };
        if (this.gpaEligible && this.workEligible) {
            data['gpa_or_work'] = 3;
        } else if (this.workEligible) {
            data['gpa_or_work'] = 2;
        } else if (this.gpaEligible) {
            data['gpa_or_work'] = 1;
        } else {
            data['gpa_or_work'] = 0;
        }
        const statusName = data.status_id === 2 ? 'Accepted' : 'Rejected';
        const body = {
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            data: data
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to submit the <span style="font-weight: bold">' + statusName
                + '</span> status to the student <span style="font-weight: bold">' + this.oneStudentStatus.student_name + '</span> ?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(body, Constants.REGISTERED_STUDENTS).subscribe(response => {
                        registrationStatusResponse = response;
                        resolve(registrationStatusResponse);
                    }, error => {
                        registrationStatusResponse = error;
                        reject(registrationStatusResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (registrationStatusResponse.status === 'success') {
                    that.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        that.router.navigate(['application-oia/outgoing']));
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully submitted the <span style="font-weight: bold">' + statusName
                            + '</span> status to the student <span style="font-weight: bold">'
                            + that.oneStudentStatus.student_name + '</span></p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                    that.closeModal();
                } else if (registrationStatusResponse.status === 'fail') {
                    if (registrationStatusResponse.hasOwnProperty('message') && registrationStatusResponse.message !== null &&
                        registrationStatusResponse.message !== '' && registrationStatusResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to submit the <span style="font-weight: bold">' + statusName
                                + '</span> status to the student <span style="font-weight: bold">'
                                + that.oneStudentStatus.student_name + '</span></p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            if (cancel.hasOwnProperty('status') && cancel.status === 404) {
                Swal({
                    type: 'error',
                    title: 'Fail',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: cancel.message,
                }).then(function (res) {
                    console.log(res);
                }, function (timer) {
                    console.log(timer);
                });
            }
        });
    }

    openEditRegistrationModal(student) {
        this.modalReference = this.modal.open(this.editRegistrationModal, {size: 'lg', backdrop: 'static', keyboard: false});
        this.dmService.getOne(Constants.GET_REGISTERED_STUDENT_DETAILS, student.outgoing_student_id)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        if (response.hasOwnProperty('message')) {
                            this.viewErrorMessage = response.message;
                        } else {
                            this.oneStudent = response.data;
                        }
                    } else if (response.status === 'fail') {
                        this.viewErrorMessage = response.message;
                    }
                },
                error => {
                    console.log(error);
                    this.viewErrorMessage = error;
                });
    }

    editRegistration() {
        let editRegistrationResponse;
        const that = this;
        const body = {
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            data: this.oneStudent
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: '<p>Do you want to change the student details?</p>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.bulkUpload(body, Constants.EDIT_REGISTERED_STUDENT).subscribe(response => {
                        editRegistrationResponse = response;
                        resolve(editRegistrationResponse);
                    }, error => {
                        editRegistrationResponse = error;
                        reject(editRegistrationResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (editRegistrationResponse.status === 'success') {
                    that.getRegisteredStudents();
                    that.closeModal();
                    Swal({
                        type: 'success',
                        title: 'Success',
                        width: 600,
                        padding: 80,
                        showCancelButton: false,
                        showConfirmButton: true,
                        html: '<p>Successfully changed the student details</p>',
                    }).then(function (res) {
                        console.log(res);
                    }, function (timer) {
                        console.log(timer);
                    });
                } else if (editRegistrationResponse.status === 'fail') {
                    if (editRegistrationResponse.hasOwnProperty('message') && editRegistrationResponse.message !== null &&
                        editRegistrationResponse.message !== '' && editRegistrationResponse.message !== undefined) {
                        Swal({
                            type: 'error',
                            title: 'Fail',
                            width: 600,
                            padding: 80,
                            showCancelButton: false,
                            showConfirmButton: true,
                            html: '<p>Failed to change the student details</p>',
                        }).then(function (res) {
                            console.log(res);
                        }, function (timer) {
                            console.log(timer);
                        });
                    }
                }
            }
        }, function (cancel) {
            if (cancel.hasOwnProperty('status') && cancel.status === 404) {
                Swal({
                    type: 'error',
                    title: 'Fail',
                    width: 600,
                    padding: 80,
                    showCancelButton: false,
                    showConfirmButton: true,
                    html: cancel.message,
                }).then(function (res) {
                    console.log(res);
                }, function (timer) {
                    console.log(timer);
                });
            }
        });
    }

    openDownloadDocumentModal() {
        this.modalReference = this.modal.open(this.downloadStudentDocumentModal, {size: 'lg', backdrop: 'static', keyboard: false});
    }
    getDocumentTypeName() {
        for (let doc of this.documentTypes) {
            if (doc.document_type_id == this.documentTypeId) {
                return doc.name
            }
        }
    }

    getTermName() {
        for (let term of this.outgoingTerm) {
            if (term.outgoing_term_id == this.termId) {
                return term.outgoing_term_name
            }
        }
    }
    downloadStudentDocuments(e) {
        e.preventDefault();
        if (this.termId == undefined || this.documentTypeId == undefined) {
            this.toastr.info("Please select Term and Document Type to download", "Required");
            return;
        }
        const finalData = {
            term_id: this.termId,
            document_type_id: this.documentTypeId,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id
        };
        const fileName = this.getTermName() + '_' + this.getDocumentTypeName();
        const api = AppSettings.JAVA_API + AppSettings.DOWNLOAD_OUTGOING_STUDENT_DOCUMENTS;
        const that = this;
        let downloadResponse;
        Swal({
            title: 'Confirm',
            type: 'question',
            text: 'Documents will be downloaded from ' + this.getTermName() + ' Term and ' + this.getDocumentTypeName(),
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#4cb84c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                return new Promise(function (resolve, reject) {
                    that.dmService.downloadFile(finalData, api).subscribe(data => {
                        saveAs(data, fileName + '.zip');
                        downloadResponse = { status: true };
                        resolve(downloadResponse);
                        that.closeModal();
                    }, error => {
                        downloadResponse = error;
                        reject(downloadResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            
        });
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    closeModal(): void {
        this.modalReference.close();
        this.viewErrorMessage = undefined;
        this.oneStudent = undefined;
        this.studentDocuments = undefined;
        this.termStudentDetails = undefined;
        this.formData = undefined;
        this.gpaEligible = undefined;
        this.workEligible = undefined;
        this.gpaOrWork = undefined;
        this.termId = undefined;
        this.documentTypeId = undefined;
    }


    ngOnInit() {
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
        this.getAllTerms();
        this.getRegisteredStudents();
    }


}
